// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__SH-9E {
  align-items: center;
  color: #18316e;
  display: flex;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.styles_container_upload__dhuMM {
  align-items: center;
  background: #dfdddd;
  border: 3.5px dashed #18316e;
  border-radius: 8px;
  color: #868686;
  display: flex;
  flex-direction: column;
  height: 250px;
  justify-content: center;
  margin-bottom: 0.3rem;
  position: relative;
  transition: 500ms all;
  width: 100%;
  &:hover {
    background: #c7c7c7;
    border-color: #1f3a7e;
    color: #5e5d5d;
  }
}

.styles_input__0DbKo {
  cursor: pointer;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}
.styles_btn_visualizador__GzKJs {
  background: #18316e !important;
  &:hover {
    background: #1f3a7e !important;
  }
}

.styles_container_btn__HN-9O {
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 1rem;
  padding: 0 !important;
}

.styles_btn_close__BpC-W {
  border: 2px solid #18316e !important;
  color: #18316e !important;
  transition: 500ms all !important;
  &:hover {
    background: #18316e !important;
    border: 2px solid #18316e !important;
    color: #fff !important;
  }
}

.styles_btn_avancar__P37gO {
  background: #18316e !important;
}

.styles_info_btn__2Llzg {
  border: 1px solid #90bce9;
  border-radius: 3px;
  color: #90bce9;
}

.styles_accordion__5er-p {
  display: inline-block;
  height: 50px;
  overflow: hidden;
  transition: width 0.4s ease, height 0.4s ease 0.4s;
  width: 150px;
}

.styles_open__CJKIR {
  height: auto;
  transition: width 0.4s ease, height 0.4s ease 0.4s;
  width: 100%;
}

.styles_accordionHeader__tuF4R {
  align-items: center;
  border: none;
  border-radius: 5px;
  color: #18316e !important;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
}

.styles_accordionContent__IrA3b {
  max-height: 0;
  padding-left: 0.5rem;
  opacity: 0;
  overflow: hidden;
  transition: opacity 0.8s ease, max-height 0.4s ease;
}

.styles_open__CJKIR .styles_accordionContent__IrA3b {
  border: 1px solid rgb(207, 207, 207);
  border-radius: 7px;
  margin-bottom: 1rem;
  max-height: 500px;
  opacity: 1;
  transition: opacity 0.8s ease 0.4s, max-height 0.4s ease 0.4s;
}

.styles_container_legenda__Ghm-b {
  display: flex;
  justify-content: flex-end;
}

.styles_container_legenda__Ghm-b h4 {
  color: #18316e;
}

.styles_info_legenda__ZGfAX {
  display: flex;
  align-items: center;
  margin: 1rem 0;
}

.styles_container_btn_legenda__Nwmhy {
  display: flex;
  width: 100%;
}

.styles_btn_legenda_esq__muODN {
  display: flex;
  flex-direction: column;
  width: 25rem;
  margin-bottom: 1rem;
}

.styles_btn_legenda_dir__O9D9B {
  display: flex;
  flex-direction: column;
}
.styles_pesquisa_signatario__QX3OF {
  justify-content: center;
  text-align: center;
  font-weight: 500;
}

.styles_container_add_signatario__pYQMB {
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
  color: #18316e;
}

.styles_conteinerBtnSignatarios__RHo86 {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.styles_container_crud__YRlct {
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
  color: #18316e;
}

.styles_conteinerBtnCrud__CQQJI {
  display: flex;
  gap: 1rem;
  justify-content: space-around;
  width: 100%;
}

.styles_container__users__Hfrdi {
  display: flex;
  flex-direction: column;
  max-height: 20rem;
  overflow-y: scroll;
}

.styles_topic__users__3zKz6 {
  display: flex;
  gap: 0.5em;
  max-width: 30rem;
  padding: 0.5rem;
  border-bottom: 1px solid #c7c7c7;
}

.styles_topic__users_checker__Tdq1M {
  background-color: #e2f2ff;
}

.styles_topic__users__3zKz6:hover {
  cursor: pointer;
  background-color: #d9d9d9;
}

.styles_topic__users__3zKz6 span {
  font-size: 1rem;
  font-family: "Inter";
  font-weight: 500;
}

.styles_containerTopic__signatario__7FiVY {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AnexoContrato/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;EACxB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".header {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.container_upload {\n  align-items: center;\n  background: #dfdddd;\n  border: 3.5px dashed #18316e;\n  border-radius: 8px;\n  color: #868686;\n  display: flex;\n  flex-direction: column;\n  height: 250px;\n  justify-content: center;\n  margin-bottom: 0.3rem;\n  position: relative;\n  transition: 500ms all;\n  width: 100%;\n  &:hover {\n    background: #c7c7c7;\n    border-color: #1f3a7e;\n    color: #5e5d5d;\n  }\n}\n\n.input {\n  cursor: pointer;\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n}\n.btn_visualizador {\n  background: #18316e !important;\n  &:hover {\n    background: #1f3a7e !important;\n  }\n}\n\n.container_btn {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-top: 1rem;\n  padding: 0 !important;\n}\n\n.btn_close {\n  border: 2px solid #18316e !important;\n  color: #18316e !important;\n  transition: 500ms all !important;\n  &:hover {\n    background: #18316e !important;\n    border: 2px solid #18316e !important;\n    color: #fff !important;\n  }\n}\n\n.btn_avancar {\n  background: #18316e !important;\n}\n\n.info_btn {\n  border: 1px solid #90bce9;\n  border-radius: 3px;\n  color: #90bce9;\n}\n\n.accordion {\n  display: inline-block;\n  height: 50px;\n  overflow: hidden;\n  transition: width 0.4s ease, height 0.4s ease 0.4s;\n  width: 150px;\n}\n\n.open {\n  height: auto;\n  transition: width 0.4s ease, height 0.4s ease 0.4s;\n  width: 100%;\n}\n\n.accordionHeader {\n  align-items: center;\n  border: none;\n  border-radius: 5px;\n  color: #18316e !important;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  width: 100%;\n}\n\n.accordionContent {\n  max-height: 0;\n  padding-left: 0.5rem;\n  opacity: 0;\n  overflow: hidden;\n  transition: opacity 0.8s ease, max-height 0.4s ease;\n}\n\n.open .accordionContent {\n  border: 1px solid rgb(207, 207, 207);\n  border-radius: 7px;\n  margin-bottom: 1rem;\n  max-height: 500px;\n  opacity: 1;\n  transition: opacity 0.8s ease 0.4s, max-height 0.4s ease 0.4s;\n}\n\n.container_legenda {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.container_legenda h4 {\n  color: #18316e;\n}\n\n.info_legenda {\n  display: flex;\n  align-items: center;\n  margin: 1rem 0;\n}\n\n.container_btn_legenda {\n  display: flex;\n  width: 100%;\n}\n\n.btn_legenda_esq {\n  display: flex;\n  flex-direction: column;\n  width: 25rem;\n  margin-bottom: 1rem;\n}\n\n.btn_legenda_dir {\n  display: flex;\n  flex-direction: column;\n}\n.pesquisa_signatario {\n  justify-content: center;\n  text-align: center;\n  font-weight: 500;\n}\n\n.container_add_signatario {\n  padding: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.3rem;\n  color: #18316e;\n}\n\n.conteinerBtnSignatarios {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.container_crud {\n  padding: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.3rem;\n  color: #18316e;\n}\n\n.conteinerBtnCrud {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-around;\n  width: 100%;\n}\n\n.container__users {\n  display: flex;\n  flex-direction: column;\n  max-height: 20rem;\n  overflow-y: scroll;\n}\n\n.topic__users {\n  display: flex;\n  gap: 0.5em;\n  max-width: 30rem;\n  padding: 0.5rem;\n  border-bottom: 1px solid #c7c7c7;\n}\n\n.topic__users_checker {\n  background-color: #e2f2ff;\n}\n\n.topic__users:hover {\n  cursor: pointer;\n  background-color: #d9d9d9;\n}\n\n.topic__users span {\n  font-size: 1rem;\n  font-family: \"Inter\";\n  font-weight: 500;\n}\n\n.containerTopic__signatario {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__SH-9E`,
	"container_upload": `styles_container_upload__dhuMM`,
	"input": `styles_input__0DbKo`,
	"btn_visualizador": `styles_btn_visualizador__GzKJs`,
	"container_btn": `styles_container_btn__HN-9O`,
	"btn_close": `styles_btn_close__BpC-W`,
	"btn_avancar": `styles_btn_avancar__P37gO`,
	"info_btn": `styles_info_btn__2Llzg`,
	"accordion": `styles_accordion__5er-p`,
	"open": `styles_open__CJKIR`,
	"accordionHeader": `styles_accordionHeader__tuF4R`,
	"accordionContent": `styles_accordionContent__IrA3b`,
	"container_legenda": `styles_container_legenda__Ghm-b`,
	"info_legenda": `styles_info_legenda__ZGfAX`,
	"container_btn_legenda": `styles_container_btn_legenda__Nwmhy`,
	"btn_legenda_esq": `styles_btn_legenda_esq__muODN`,
	"btn_legenda_dir": `styles_btn_legenda_dir__O9D9B`,
	"pesquisa_signatario": `styles_pesquisa_signatario__QX3OF`,
	"container_add_signatario": `styles_container_add_signatario__pYQMB`,
	"conteinerBtnSignatarios": `styles_conteinerBtnSignatarios__RHo86`,
	"container_crud": `styles_container_crud__YRlct`,
	"conteinerBtnCrud": `styles_conteinerBtnCrud__CQQJI`,
	"container__users": `styles_container__users__Hfrdi`,
	"topic__users": `styles_topic__users__3zKz6`,
	"topic__users_checker": `styles_topic__users_checker__Tdq1M`,
	"containerTopic__signatario": `styles_containerTopic__signatario__7FiVY`
};
export default ___CSS_LOADER_EXPORT___;
